module.exports = "/images/fr.svg?c4faf9674c396f97ca0bc87f9fb153cd";